import React from 'react';
import {useParams} from 'react-router';
import {LocaleKey} from '../i18n';
import {PrivacyScreen} from '../screens';

const PrivacyRoute: React.FC = () => {
  const {lang} = useParams<{lang: LocaleKey}>();

  return <PrivacyScreen lang={lang} />;
};

export {PrivacyRoute};
